import { Alert, CircularProgress } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import MaterialTextField from 'src/components/material/textField';
import featureStyles from '../../RegisterModalShared.module.scss';

export interface SecondStepProps {
  code: string;
  newPassword: string;
  setCode: (value: string) => void;
  setNewPassword: (value: string) => void;
  error: { code?: string; newPassword?: string; general?: string } | null;
  handleConfirmResetPassword: (event: React.FormEvent<HTMLFormElement>) => void;
  loading: boolean;
  goToLogin: () => void;
}

export const SecondStep: React.FC<SecondStepProps> = ({
  error,
  code,
  newPassword,
  setCode,
  setNewPassword,
  handleConfirmResetPassword,
  loading,
  goToLogin,
}) => {
  return (
    <section className={featureStyles.content}>
      <h1 className={featureStyles.title}>Reset Password</h1>

      <form
        onSubmit={handleConfirmResetPassword}
        className={featureStyles.form}
        noValidate
      >
        {error?.general && <Alert severity="error">{error?.general}</Alert>}

        <span>
          <MaterialTextField
            id="code"
            name="code"
            label="Verification Code"
            value={code}
            color="primary"
            variant="outlined"
            error={!!error?.code}
            helperText={error?.code}
            onChange={(event) => setCode(event.target.value)}
          />
          <MaterialTextField
            id="newPassword"
            name="newPassword"
            label="New Password"
            value={newPassword}
            color="primary"
            variant="outlined"
            isPassword
            error={!!error?.newPassword}
            helperText={error?.newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
          />
        </span>

        <button
          type="submit"
          className={clsx(
            featureStyles.button,
            featureStyles['button--primary']
          )}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress sx={{ color: '#fff' }} size={28} thickness={4} />
          ) : (
            'Reset Password'
          )}
        </button>
      </form>

      <div className={featureStyles.footer}>
        Remember your password?
        <button
          className={clsx(
            featureStyles.link,
            featureStyles['link__button'],
            featureStyles['link--primary']
          )}
          onClick={goToLogin}
        >
          Login
        </button>
      </div>
    </section>
  );
};
